export type QueueMetricRow = {
  key: string;
  name: string;
  count: number;
  width: number;
};

const queueName = (key: string) => {
  const parts = key.split(':');

  return parts.length === 2 && parts[0] === parts[1] ? parts[0] : key;
};

export const getQueueMetrics = (queueMetrics: object) => {
  const entries = Object.entries(queueMetrics)
    .filter(
      (entry): entry is [string, number] =>
        typeof entry[1] === 'number' &&
        Number.isFinite(entry[1]) &&
        entry[1] > 0,
    )
    .sort(([leftKey, left], [rightKey, right]) =>
      right === left ? leftKey.localeCompare(rightKey) : right - left,
    );
  const max = entries[0]?.[1] ?? 0;
  const rows: QueueMetricRow[] = entries.map(([key, count]) => ({
    key,
    name: queueName(key),
    count,
    width: max === 0 ? 0 : (count / max) * 100,
  }));

  return {
    rows,
    total: rows.reduce((sum, row) => sum + row.count, 0),
  };
};
